import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LegalPages.css';

const PrivacyPolicy = () => {
  // Phone number
  const phoneNumber = '+918019472678';
  const emailAddress = 'info@hotelsinhyderabad.com';

  return (
    <div className="legal-page-wrapper">
      {/* Hero Banner */}
      <div className="legal-hero-section">
        <div className="legal-hero-overlay">
          <div className="legal-hero-content">
            <span className="legal-hero-badge">✦ Legal</span>
            <h1 className="legal-hero-title">
              Privacy <span className="legal-hero-highlight">Policy</span>
            </h1>
            <p className="legal-hero-subtitle">
              Your privacy matters to us. Learn how we protect your information.
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="legal-content-section">
        <div className="legal-container">
          <div className="legal-content-wrapper">
            <div className="legal-sidebar">
              <h3>Quick Navigation</h3>
              <ul className="legal-sidebar-list">
                <li><a href="#information">Information We Collect</a></li>
                <li><a href="#usage">How We Use Information</a></li>
                <li><a href="#sharing">Information Sharing</a></li>
                <li><a href="#security">Data Security</a></li>
                <li><a href="#cookies">Cookies</a></li>
                <li><a href="#rights">Your Rights</a></li>
                <li><a href="#contact-privacy">Contact Us</a></li>
              </ul>
              <div className="legal-sidebar-back">
                <Link to="/" className="legal-back-btn">← Back to Home</Link>
              </div>
            </div>

            <div className="legal-main-content">
              <div className="legal-updated">Last Updated: January 2026</div>

              <section id="information" className="legal-section">
                <h2>1. Information We Collect</h2>
                <p>
                  At AA GRAND HOTEL, we collect information to provide you with the best possible service. 
                  The information we collect includes:
                </p>
                <ul>
                  <li><strong>Personal Information:</strong> Name, email address, phone number, and address</li>
                  <li><strong>Booking Information:</strong> Check-in/out dates, room preferences, and special requests</li>
                  <li><strong>Payment Information:</strong> Payment details for booking confirmations</li>
                  <li><strong>Usage Data:</strong> How you interact with our website and services</li>
                  <li><strong>Device Information:</strong> Browser type, IP address, and device type</li>
                </ul>
              </section>

              <section id="usage" className="legal-section">
                <h2>2. How We Use Your Information</h2>
                <p>We use your information to:</p>
                <ul>
                  <li>Process and confirm your hotel bookings</li>
                  <li>Communicate with you about your stay</li>
                  <li>Provide customer support and respond to inquiries</li>
                  <li>Improve our services and user experience</li>
                  <li>Send promotional offers and updates (with your consent)</li>
                  <li>Ensure compliance with legal obligations</li>
                </ul>
              </section>

              <section id="sharing" className="legal-section">
                <h2>3. Information Sharing</h2>
                <p>
                  We do not sell or rent your personal information to third parties. 
                  We may share your information with:
                </p>
                <ul>
                  <li><strong>Service Providers:</strong> Payment processors, booking systems, and IT support</li>
                  <li><strong>Legal Compliance:</strong> When required by law or to protect our rights</li>
                  <li><strong>Business Transfers:</strong> In case of merger, acquisition, or asset sale</li>
                </ul>
                <p className="legal-note">
                  All third-party service providers are bound by confidentiality agreements.
                </p>
              </section>

              <section id="security" className="legal-section">
                <h2>4. Data Security</h2>
                <p>
                  We implement appropriate technical and organizational measures to protect your personal information:
                </p>
                <ul>
                  <li>SSL encryption for data transmission</li>
                  <li>Secure servers and firewalls</li>
                  <li>Regular security audits and updates</li>
                  <li>Access controls and employee training</li>
                  <li>Regular data backup procedures</li>
                </ul>
                <p className="legal-note">
                  While we strive to protect your information, no method of transmission over the internet is 100% secure.
                </p>
              </section>

              <section id="cookies" className="legal-section">
                <h2>5. Cookies</h2>
                <p>
                  We use cookies to enhance your browsing experience. Cookies are small text files stored on your device.
                </p>
                <ul>
                  <li><strong>Essential Cookies:</strong> Required for website functionality</li>
                  <li><strong>Analytics Cookies:</strong> Help us understand how visitors use our site</li>
                  <li><strong>Preference Cookies:</strong> Remember your settings and preferences</li>
                </ul>
                <p>
                  You can control cookie preferences in your browser settings. However, disabling cookies may affect website functionality.
                </p>
              </section>

              <section id="rights" className="legal-section">
                <h2>6. Your Rights</h2>
                <p>You have the right to:</p>
                <ul>
                  <li>Access your personal information</li>
                  <li>Correct inaccurate or incomplete information</li>
                  <li>Request deletion of your information</li>
                  <li>Object to processing of your information</li>
                  <li>Withdraw consent at any time</li>
                  <li>Lodge a complaint with regulatory authorities</li>
                </ul>
                <p className="legal-note">
                  To exercise your rights, please contact us using the information below.
                </p>
              </section>

              <section id="contact-privacy" className="legal-section">
                <h2>7. Contact Us</h2>
                <p>If you have any questions about this Privacy Policy, please contact us:</p>
                <div className="legal-contact-info">
                  <p><strong>AA GRAND HOTEL</strong></p>
                  <p>Ameerpet Metro Pillar No. 1072,</p>
                  <p>Above Bata Showroom, First Floor,</p>
                  <p>Hyderabad, Telangana</p>
                  <p>📞 <a href={`tel:${phoneNumber}`}>{phoneNumber}</a></p>
                  <p>📧 <a href={`mailto:${emailAddress}`}>{emailAddress}</a></p>
                </div>
              </section>

              <div className="legal-back-to-top">
                <a href="#top" className="legal-top-btn">↑ Back to Top</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;